import { CompanyAccountRole } from 'src/features/companyAccounts/companyAccounts.types';

export const companyAccountRoleLocaleId = (role: CompanyAccountRole): string => {
  switch (role) {
    case CompanyAccountRole.admin:
      return 'company.account.role.admin';
    case CompanyAccountRole.accountant:
      return 'company.account.role.accountant';
    case CompanyAccountRole.engineer:
      return 'company.account.role.engineer';
    case CompanyAccountRole.observer:
      return 'company.account.role.observer';
    case CompanyAccountRole.reception:
      return 'company.account.role.reception';
    case CompanyAccountRole.airpano:
      return 'company.account.role.airpano';
    default:
      return 'company.account.role.unknown';
  }
};
